function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license
 * Copyright (c) 2021 - 2023 Vaadin Ltd.
 * This program is available under Apache License Version 2.0, available at https://vaadin.com/license/
 */
import { dedupingMixin } from '@polymer/polymer/lib/utils/mixin.js';
import { FocusMixin } from './focus-mixin.js';
import { TabindexMixin } from './tabindex-mixin.js';
/**
 * A mixin to forward focus to an element in the light DOM.
 *
 * @polymerMixin
 * @mixes FocusMixin
 * @mixes TabindexMixin
 */

export var DelegateFocusMixin = dedupingMixin(function (superclass) {
  return /*#__PURE__*/function (_FocusMixin) {
    _inherits(DelegateFocusMixinClass, _FocusMixin);

    var _super = _createSuper(DelegateFocusMixinClass);

    function DelegateFocusMixinClass() {
      var _this;

      _classCallCheck(this, DelegateFocusMixinClass);

      _this = _super.call(this);
      _this._boundOnBlur = _this._onBlur.bind(_assertThisInitialized(_this));
      _this._boundOnFocus = _this._onFocus.bind(_assertThisInitialized(_this));
      return _this;
    }
    /** @protected */


    _createClass(DelegateFocusMixinClass, [{
      key: "ready",
      value: function ready() {
        var _this2 = this;

        _get(_getPrototypeOf(DelegateFocusMixinClass.prototype), "ready", this).call(this);

        if (this.autofocus && !this.disabled) {
          requestAnimationFrame(function () {
            _this2.focus();

            _this2.setAttribute('focus-ring', '');
          });
        }
      }
      /**
       * @protected
       * @override
       */

    }, {
      key: "focus",
      value: function focus() {
        if (this.focusElement && !this.disabled) {
          this.focusElement.focus();
        }
      }
      /**
       * @protected
       * @override
       */

    }, {
      key: "blur",
      value: function blur() {
        if (this.focusElement) {
          this.focusElement.blur();
        }
      }
      /**
       * @protected
       * @override
       */

    }, {
      key: "click",
      value: function click() {
        if (this.focusElement && !this.disabled) {
          this.focusElement.click();
        }
      }
      /** @protected */

    }, {
      key: "_focusElementChanged",
      value: function _focusElementChanged(element, oldElement) {
        if (element) {
          element.disabled = this.disabled;

          this._addFocusListeners(element);

          this.__forwardTabIndex(this.tabindex);
        } else if (oldElement) {
          this._removeFocusListeners(oldElement);
        }
      }
      /**
       * @param {HTMLElement} element
       * @protected
       */

    }, {
      key: "_addFocusListeners",
      value: function _addFocusListeners(element) {
        element.addEventListener('blur', this._boundOnBlur);
        element.addEventListener('focus', this._boundOnFocus);
      }
      /**
       * @param {HTMLElement} element
       * @protected
       */

    }, {
      key: "_removeFocusListeners",
      value: function _removeFocusListeners(element) {
        element.removeEventListener('blur', this._boundOnBlur);
        element.removeEventListener('focus', this._boundOnFocus);
      }
      /**
       * Focus event does not bubble, so we dispatch it manually
       * on the host element to support adding focus listeners
       * when the focusable element is placed in light DOM.
       * @param {FocusEvent} event
       * @protected
       */

    }, {
      key: "_onFocus",
      value: function _onFocus(event) {
        event.stopPropagation();
        this.dispatchEvent(new Event('focus'));
      }
      /**
       * Blur event does not bubble, so we dispatch it manually
       * on the host element to support adding blur listeners
       * when the focusable element is placed in light DOM.
       * @param {FocusEvent} event
       * @protected
       */

    }, {
      key: "_onBlur",
      value: function _onBlur(event) {
        event.stopPropagation();
        this.dispatchEvent(new Event('blur'));
      }
      /**
       * @param {FocusEvent} event
       * @return {boolean}
       * @protected
       * @override
       */

    }, {
      key: "_shouldSetFocus",
      value: function _shouldSetFocus(event) {
        return event.target === this.focusElement;
      }
      /**
       * @param {FocusEvent} event
       * @return {boolean}
       * @protected
       * @override
       */

    }, {
      key: "_shouldRemoveFocus",
      value: function _shouldRemoveFocus(event) {
        return event.target === this.focusElement;
      }
      /**
       * @param {boolean} disabled
       * @param {boolean} oldDisabled
       * @protected
       * @override
       */

    }, {
      key: "_disabledChanged",
      value: function _disabledChanged(disabled, oldDisabled) {
        _get(_getPrototypeOf(DelegateFocusMixinClass.prototype), "_disabledChanged", this).call(this, disabled, oldDisabled);

        if (this.focusElement) {
          this.focusElement.disabled = disabled;
        }

        if (disabled) {
          this.blur();
        }
      }
      /**
       * Override an observer from `TabindexMixin`.
       * Do not call super to remove tabindex attribute
       * from the host after it has been forwarded.
       * @param {string} tabindex
       * @protected
       * @override
       */

    }, {
      key: "_tabindexChanged",
      value: function _tabindexChanged(tabindex) {
        this.__forwardTabIndex(tabindex);
      }
      /** @private */

    }, {
      key: "__forwardTabIndex",
      value: function __forwardTabIndex(tabindex) {
        if (tabindex !== undefined && this.focusElement) {
          this.focusElement.tabIndex = tabindex; // Preserve tabindex="-1" on the host element

          if (tabindex !== -1) {
            this.tabindex = undefined;
          }
        }

        if (this.disabled && tabindex) {
          // If tabindex attribute was changed while component was disabled
          if (tabindex !== -1) {
            this._lastTabIndex = tabindex;
          }

          this.tabindex = undefined;
        }
      }
    }], [{
      key: "properties",
      get: function get() {
        return {
          /**
           * Specify that this control should have input focus when the page loads.
           */
          autofocus: {
            type: Boolean
          },

          /**
           * A reference to the focusable element controlled by the mixin.
           * It can be an input, textarea, button or any element with tabindex > -1.
           *
           * Any component implementing this mixin is expected to provide it
           * by using `this._setFocusElement(input)` Polymer API.
           *
           * Toggling `tabindex` attribute on the host element propagates its value to `focusElement`.
           *
           * @protected
           * @type {!HTMLElement}
           */
          focusElement: {
            type: Object,
            readOnly: true,
            observer: '_focusElementChanged'
          },

          /**
           * Override the property from `TabIndexMixin`
           * to ensure the `tabindex` attribute of the focus element
           * will be restored to `0` after re-enabling the element.
           *
           * @protected
           * @override
           */
          _lastTabIndex: {
            value: 0
          }
        };
      }
    }]);

    return DelegateFocusMixinClass;
  }(FocusMixin(TabindexMixin(superclass)));
});